import { NAV } from '../lib/navigationConfig'

const C = {
  ink: '#0F1017', sub: '#6B7280', muted: '#9CA3AF',
  paper: '#F3F4F6', surface: '#fff', border: '#E5E7EB',
  green: '#1A7A4A',
}

// Icons matching the stroke-based style used throughout HomeLaunchpad.jsx /
// App.jsx -- not Tabler webfont, which is confirmed unused anywhere else in
// this codebase.
const ICONS = {
  'Cash In / Out':      <path d="M2 8h12M2 8l3-3M2 8l3 3M14 8l-3-3M14 8l-3 3"/>,
  'Cashflow':            <path d="M1.5 12l3.5-5 3 2.5 3-4.5 3.5 3"/>,
  'Cash Out':            <><rect x="1.5" y="5" width="13" height="8" rx="1"/><circle cx="8" cy="9" r="1.5"/></>,
  'CF Expectation':      <><rect x="2" y="2" width="12" height="12" rx="1"/><path d="M5 6h6M5 9h4"/></>,
  'Cash Out Forecast':   <><path d="M1.5 12l3.5-5 3 2.5 3-4.5 3.5 3"/><path d="M11 4h3.5v3.5"/></>,
  'CF Packages':         <><rect x="2" y="4" width="12" height="9" rx="1"/><path d="M2 7h12"/><path d="M5.5 4V2.5h5V4"/></>,
  'Financial Fees':      <><rect x="3" y="1.5" width="10" height="13" rx="1"/><line x1="6" y1="5" x2="10" y2="5"/><line x1="6" y1="8" x2="10" y2="8"/></>,
  'PO Lines':            <><path d="M2 2h1.5l1.8 7h7l1.7-5H5.3"/><circle cx="7" cy="13.5" r="1"/><circle cx="11" cy="13.5" r="1"/></>,
}

const GROUPS = [
  { label: 'Cash movement', tabs: ['Cash In / Out', 'Cashflow', 'Cash Out'] },
  { label: 'Planning', tabs: ['CF Expectation', 'Cash Out Forecast', 'CF Packages'] },
  { label: 'Procurement-linked', tabs: ['Financial Fees', 'PO Lines'] },
]

export default function FinanceLandingPage({ onNavigate }) {
  const financeNav = NAV.find(n => n.key === 'finance')

  return (
    <div style={{ padding: '24px 28px', maxWidth: 780 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
        <svg viewBox="0 0 16 16" style={{ width: 20, height: 20, color: C.sub }} fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="8" cy="8" r="6.5"/><line x1="8" y1="4" x2="8" y2="5.5"/><line x1="8" y1="10.5" x2="8" y2="12"/>
          <path d="M6 7c0-1 .9-1.5 2-1.5s2 .5 2 1.5-1 1.5-2 1.5-2 .5-2 1.5.9 1.5 2 1.5 2-.5 2-1.5"/>
        </svg>
        <h1 style={{ fontSize: 18, fontWeight: 600, color: C.ink, margin: 0 }}>Finance</h1>
      </div>
      <p style={{ fontSize: 12.5, color: C.sub, margin: '0 0 20px' }}>
        {financeNav?.sub || '8 sections, grouped by purpose'}
      </p>

      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 12 }}>
        {GROUPS.map(group => (
          <div key={group.label} style={{ border: `1px solid ${C.border}`, borderRadius: 8, padding: 12, background: C.surface }}>
            <div style={{ fontSize: 9, fontWeight: 700, textTransform: 'uppercase', letterSpacing: '.08em', color: C.muted, marginBottom: 8 }}>
              {group.label}
            </div>
            {group.tabs.map(tabLabel => (
              <button
                key={tabLabel}
                onClick={() => onNavigate('finance-detail')}
                style={{
                  display: 'flex', alignItems: 'center', gap: 7, width: '100%',
                  fontSize: 12, color: '#374151', padding: '5px 2px',
                  background: 'none', border: 'none', textAlign: 'left', cursor: 'pointer',
                }}
                onMouseEnter={e => { e.currentTarget.style.color = C.green }}
                onMouseLeave={e => { e.currentTarget.style.color = '#374151' }}
              >
                <svg viewBox="0 0 16 16" style={{ width: 13, height: 13, color: C.muted, flexShrink: 0 }} fill="none" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
                  {ICONS[tabLabel]}
                </svg>
                {tabLabel}
              </button>
            ))}
          </div>
        ))}
      </div>
    </div>
  )
}
